var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-chat"},[(_vm.isCompanyLoading)?_c('loading'):(!_vm.company)?_c('CompanyNotFound'):_c(_vm.activeComponent,{tag:"component",attrs:{"iframeWebsite":_vm.iframeWebsite,"company":_vm.company},on:{"start:chat":function($event){_vm.activeComponent = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }